/**
 * Values for the `control-size` attribute on TextInput elements.
 *
 * @public
 */
export const TextInputControlSizes = {
    small: "small",
    medium: "medium",
    large: "large"
};
/**
 * Values for the `appearance` attribute on TextInput elements.
 *
 * @public
 */
export const TextInputAppearances = {
    outline: "outline",
    underline: "underline",
    filledLighter: "filled-lighter",
    filledDarker: "filled-darker"
};
/**
 * Values for the `type` attribute on TextInput elements.
 *
 * @public
 */
export const TextInputTypes = {
    email: "email",
    password: "password",
    number: "number",
    tel: "tel",
    text: "text",
    url: "url"
};
/**
 * Input types that block implicit form submission.
 *
 * @public
 */
export const ImplicitSubmissionBlockingTypes = [
    "date",
    "datetime-local",
    "email",
    "month",
    "number",
    "password",
    "search",
    "tel",
    "text",
    "time",
    "url",
    "week"
];
//# sourceMappingURL=text-input.options.js.map